import { getElementOffset } from '../helpers/general';

document.querySelectorAll('.bg-special-wrapper').forEach((bgWrapper) => {
  const cardElements = bgWrapper.querySelectorAll('.card');

  if (!cardElements.length) {
    return;
  }

  const wrapperOffset = getElementOffset(bgWrapper);
  const wrapperBottom = wrapperOffset.top + bgWrapper.offsetHeight;

  const lastCard = cardElements[cardElements.length - 1];
  const lastCardOffset = getElementOffset(lastCard);
  const lastCardBottom = lastCardOffset.top + lastCard.getBoundingClientRect().height;

  bgWrapper.querySelectorAll('.bg-special-container').forEach((container) => {
    container.style.bottom = (wrapperBottom - lastCardBottom) + 100;
  });
});
